import React, { useEffect, useState } from "react";
import {
  Col,
  Nav,
  Row,
  Card,
  Table,
  Button,
  ListGroup,
  Container,
} from "react-bootstrap";
import useAxios from "../../hooks/useAxios";
import { useNavigate, useParams } from "react-router-dom";
import SupplyRecordForm from "../../Components/PurchaseOrder/SupplyRecordForm";
import { Loading } from "../../Components/Loading";

const PurchaseOrderSupplyRecord = () => {
  const { get } = useAxios();
  const navigate = useNavigate();
  let { purchaseOrderId } = useParams();
  const [vendor, setVendor] = useState({});
  const [kitItems, setKitItems] = useState({});
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [collector, setCollector] = useState({});
  const [orderDetails, setOrderDetails] = useState({});
  const [purchaseOrder, setPurchaseOrder] = useState({});
  const [isSummaryClicked, setIsSummaryClicked] = useState(false);

  useEffect(() => {
    setFetching(true);
    const getDetailedPurchaseOrder = async () => {
      try {
        const response = await get(`purchaseorder/${purchaseOrderId}/edit`);
        setOrderDetails(response.data);
        setCollector(response.data.received_by);
        setPurchaseOrder(response.data.purchaseOrder);
        setKitItems(response.data.purchaseOrder.items);
        setVendor(response.data.purchaseOrder.vendors);
      } catch (error) {
        if (error.response.status === 500) {
        }
      } finally {
        setFetching(false);
      }
    };
    getDetailedPurchaseOrder();
  }, []);

  return (
    <div className="page-wrapper">
      <Container fluid>
        {!!fetching && <Loading />}

        {!!orderDetails && !fetching && (
          <>
            <div className="page-header d-print-none">
              <Row className="align-items-center">
                <Col>
                  <div className="page-pretitle">
                    PURCHASE ORDER SUPPLY RECORD{" "}
                  </div>
                </Col>
              </Row>
            </div>

            <div className="page-body">
              <Nav className="justify-content-end">
                <Nav.Item>
                  <Button onClick={() => navigate(-1)}>Back</Button>
                </Nav.Item>
              </Nav>

              <br />

              <>
                <Card className="mb-5">
                  <Card.Header className="d-flex justify-content-between mt-2 mb-4">
                    <Nav className="fw-bolder fs-4 mb-3">
                      <Nav.Item
                        onClick={() => setIsSummaryClicked(!isSummaryClicked)}
                      >
                        <Nav.Link href="#">
                          <Card.Title>ORDER SUMARRY </Card.Title>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon"
                            width="10"
                            height="10"
                            viewBox="0 0 20 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M15 4v8h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-8a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1z" />
                          </svg>{" "}
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Card.Header>

                  <Card.Body className="mb-4">
                    <ListGroup className="list-group-flush">
                      {isSummaryClicked && (
                        <>
                          <ListGroup.Item>
                            <label className="fw-bolder fs-3">
                              PURCHASE ORDER NUMBER
                            </label>
                            <Card.Text className="fs-3">
                              {purchaseOrder.purchase_order_number || "N/A"}
                            </Card.Text>
                          </ListGroup.Item>

                          <ListGroup.Item>
                            <label className="fw-bolder fs-3 ">
                              VENDOR DETAILS
                            </label>

                            <Row className="mb-3">
                              <Col className="mt-3 mb-3" md={6}>
                                <label className="fw-bold fs-3 ">NAME</label>
                                <Card.Text className="fs-3">
                                  {vendor.name || "N/A"}
                                </Card.Text>
                              </Col>

                              <Col className="mt-3" md={6}>
                                <label className="fw-bold fs-3">EMAIL</label>
                                <Card.Text className="fs-3">
                                  {vendor.email || "N/A"}
                                </Card.Text>
                              </Col>
                            </Row>

                            <Row>
                              <Col className="mb-3" md={6}>
                                <label className="fw-bold fs-3 ">
                                  PRIMARY TELEPHONE
                                </label>
                                <Card.Text className="fs-3">
                                  {vendor.primary_phone || "N/A"}
                                </Card.Text>
                              </Col>

                              <Col md={6}>
                                <label className="fw-bold fs-3 ">
                                  SECONDARY TELEPHONE
                                </label>
                                <Card.Text className="fs-3">
                                  {vendor.secondary_phone || "N/A"}
                                </Card.Text>
                              </Col>
                            </Row>
                          </ListGroup.Item>

                          <ListGroup.Item>
                            <label className="fw-bolder fs-3">
                              ORDER STATUS
                            </label>
                            <Card.Text className="fs-3">
                              {`${purchaseOrder.status}`.replace(/\_/g, " ") ||
                                "N/A"}
                            </Card.Text>
                          </ListGroup.Item>
                        </>
                      )}

                      <ListGroup.Item className="mt-4">
                        <label className="fw-bolder fs-3 ">
                          GUARD KIT ITEMS DETAILS
                        </label>
                        <Table
                          responsive
                          hover
                          bordered
                          className=" table-vcenter table-mobile-md card-table mt-3"
                        >
                          <thead>
                            <tr>
                              <th>NAME</th>
                              <th>QUANTITY ORDERED</th>
                              <th>QUANTITY DELIVERED</th>
                            </tr>
                          </thead>

                          <tbody>
                            {kitItems.map((kitItem) => (
                              <tr key={kitItem.id}>
                                <td data-label="NAME">
                                  {kitItem.kit_item.name}
                                </td>

                                <td data-label="QUANTITY ORDERED">
                                  {kitItem.quantity}
                                </td>

                                <td data-label="QUANTITY DELIVERED">
                                  {`${kitItem?.quantity_delivered}` || "N/A"}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </ListGroup.Item>
                    </ListGroup>
                  </Card.Body>
                </Card>

                <br />

                <div className="d-flex justify-content-center">
                  <Card className="mb-5" style={{ width: "80%" }}>
                    <Card.Header className="d-flex justify-content-between mt-2 mb-3">
                      <Card.Title> WAYBILL</Card.Title>
                    </Card.Header>

                    <Card.Body>
                      <SupplyRecordForm
                        purchaseOrder={purchaseOrder}
                        kitItems={kitItems}
                        logisticsStaff={collector}
                      />
                    </Card.Body>
                  </Card>
                </div>
              </>
            </div>
          </>
        )}
      </Container>
    </div>
  );
};

export default PurchaseOrderSupplyRecord;
